export class AppError extends Error {
  public innerError: Error | undefined;

  public constructor(messages?: string, innerError?: Error) {
    super(messages);
    this.innerError = innerError;
  }
}

export class ApiError extends AppError {
  public statusCode: number | undefined;
  public errorCode: string | undefined;
  // レスポンスボディの error.message。同じ statusCode/errorCode でも拒否理由ごとに
  // メッセージで判別させる API (例: BoxExportRuleService の 409) を呼び出し側が識別するために使う。
  public errorMessage: string | undefined;

  public constructor(
    statusCode?: number,
    errorCode?: string,
    innerError?: Error,
    errorMessage?: string,
  ) {
    super(
      `statusCode:${statusCode}, errorCode:${errorCode}, message: ${innerError?.message}`,
      innerError,
    );
    this.statusCode = statusCode;
    this.errorCode = errorCode;
    this.errorMessage = errorMessage;
  }
}

export class ApiRequestCanceledError extends ApiError {}

export class ApiUnknownError extends ApiError {}

export class ApiConnectionError extends ApiError {}

export class ApiSophonError extends ApiError {}
export class ApiSophonMfaRequiredError extends ApiSophonError {}
// sophon が返す 401 全般 (Single Logout での失効、JWT 検証失敗等) を表す。コード名は問わない
export class ApiSophonSessionExpiredError extends ApiSophonError {}

// 組織 Cookie が確定せず、x-organization-id を付けて送信できないことを表す
export class ApiOrganizationNotSelectedError extends ApiError {
  public constructor() {
    super(undefined, 'organization_not_selected');
    this.message = 'organization is not selected';
  }
}
